import createService from './createService';
import { serviceInstances, getService, setService } from './serviceInstances';

export { createService, serviceInstances, getService, setService };
